export const costCentsToDollarsAndCents = (costCents: number): string => {
  return (costCents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};
